import { render } from "./AboutButton.vue?vue&type=template&id=d09821ce&scoped=true"
import script from "./AboutButton.vue?vue&type=script&lang=js"
export * from "./AboutButton.vue?vue&type=script&lang=js"

import "./AboutButton.vue?vue&type=style&index=0&id=d09821ce&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-d09821ce"

export default script